var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 21, offset: 2 } }, [
        _c(
          "div",
          { staticClass: "container", staticStyle: { cursor: "pointer" } },
          [
            _vm.isLoading
              ? [
                  _c("loading-skeleton", {
                    attrs: { "loading-text": "Loading..." }
                  })
                ]
              : [
                  _vm.blogList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "blog-list" },
                        [
                          _vm._l(_vm.blogList, function(blog) {
                            return _c("div", [
                              _c(
                                "article",
                                {
                                  staticClass: "blog-card",
                                  on: {
                                    click: function($event) {
                                      return _vm.redirectToBlog(blog.id)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "blog-image-outer-container"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "blog-image-container" },
                                        [
                                          _c("img", {
                                            staticClass: "blog-image",
                                            attrs: {
                                              src: blog.imageUrl,
                                              alt: "Blog post"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "blog-content" }, [
                                    _c("h1", { staticClass: "blog-title" }, [
                                      _vm._v(_vm._s(blog.title))
                                    ]),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "blog-excerpt",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.truncateHtml(blog.content)
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "blog-meta" }, [
                                      _c(
                                        "time",
                                        {
                                          staticClass: "blog-date",
                                          attrs: { datetime: blog.publishedOn }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(blog.publishedOn)
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-pagination", {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center"
                            },
                            attrs: {
                              background: "",
                              "current-page": _vm.currentPage,
                              "page-size": _vm.pageSize,
                              small: "",
                              layout: "prev, pager, next",
                              total: _vm.totalItems
                            },
                            on: { "current-change": _vm.handleCurrentChange }
                          })
                        ],
                        2
                      )
                    : _c("div", { staticClass: "empty-blog-list" }, [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/unifi-logo-new.svg")
                          }
                        })
                      ])
                ]
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9b0937c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9b0937c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/blogCardListView.vue
// module id = null
// module chunks = 